define('taoQtiItem/qtiItem/core/choices/Hotspot',['taoQtiItem/qtiItem/core/choices/Choice'], function(QtiChoice){
    var QtiHotspot = QtiChoice.extend({});
    return QtiHotspot;
});



